import { BrowserType, MaintenanceSetting, WorkingPlatform, WorkingPlatformType } from './types';

export const WORKING_PLATFORM_KEY = `BZNAV_WORKING_PLATFORM.${process.env.NEXT_PUBLIC_APP_ID}`;
export const WORKING_PLATFORM_URL_QUERY_KEY = 'working_platform';
export const PARTNER_APP_LIST: WorkingPlatform[] = ['kbank', 'toss'];
export const WORKING_PLATFORM_TYPE: Record<WorkingPlatform, WorkingPlatformType> = {
  web: 'web',
  app: 'app',
  'app-deprecated': 'app',
  care: 'web',
  kbank: 'app',
  toss: 'app',
  'joins-hr': 'web'
};

export const BROWSER_TYPE: Record<WorkingPlatform, BrowserType> = {
  web: 'system',
  app: 'webview',
  'app-deprecated': 'webview',
  care: 'iframe',
  kbank: 'webview',
  toss: 'inApp',
  'joins-hr': 'system'
};

export const BZNAV_UTM_KEY = `BZNAV_UTM.${process.env.NEXT_PUBLIC_APP_ID}.${process.env.NEXT_PUBLIC_ZENV}`;

export const MAINTENANCE_BYPASS_KEY = 'MAINTENANCE_BYPASS_QUERY';
export const MAINTENANCE_SETTING_COOKIE = 'MAINTENANCE_SETTING';
export const DEFAULT_MAINTENANCE_SETTING: MaintenanceSetting = {
  status: false,
  level: 'service',
  title: '',
  description: ''
};

export const RESOURCE_FILE_PATTERNS = ['/_next', '.svg', '.png', '.json'];
